<template>
  <div >
      <NavBar></NavBar>
     <div class="min-h-screen mt-12 sm:mx-32 ">
                <div class="text-center">
                <div class="text-center">
                  <p class="font-bold text-xl mt-8 ">Your message has been sent! We look forward to contacting you soon! </p>
                </div>
            </div>

  </div>

         <Footer></Footer>
  </div>

</template>

<script>
import {
  mapState, mapGetters, mapMutations, mapActions,
} from 'vuex';
import _ from 'lodash';
import { mixin as clickaway } from 'vue-clickaway';
import NavBar from '../components/navigation/Navbar.vue';
import Footer from '../components/footer/Footer.vue';

export default {
  components: { NavBar, Footer },
  head() {
    return {
      title: {
        inner: 'Home',
      },
      meta: [
        {
          name: 'description',
          content: `${this.appTitle} home page`,
          id: 'desc',
        },
      ],
    };
  },
  data() {
    return {
      isOpen: false,
      loading: false,
      contact: {
        email: '',
        msg: '',
      },
      msgSent: false,
      type: [
        { name: 'illness', selected: false },
        { name: 'contraceptive', selected: false },
        { name: 'other', selected: false },
      ],
      selectedType: 'allergies',
      selected: '',
      options: [
        { text: 'illness', value: 'illness' },
        { text: 'contraceptive', value: 'contraceptive' },
        { text: 'other', value: 'other' },
      ],
      restOfCities: [],
      openBox: false,
    };
  },
  mixins: [clickaway],
  computed: {
    ...mapState('search', ['dropdownMainSelected', 'mainCatSelected', 'subCatSelected', 'latestkitlist', 'dropdownIndex', 'mainOptions', 'propertylist', 'MainOptionSelected', 'SelectedOption']),
    ...mapState('app', ['appTitle']),
    ...mapState('card', ['testkitproducts']),
    loadingState() {
      return this.loading;
    },

  },
  methods: {
    ...mapActions('card', ['getTestKitProducts']),
    ...mapActions('search', ['getMainOptions', 'sendMessage', 'getTestKitProducts', 'getLatest']),
    ...mapGetters('search', ['getDropdown']),
    ...mapMutations('search', ['setDropdownMainCatIndex', 'ResetFirstOption', 'SetMainCatagory', 'SetSubCatagoryDirectly']),
    populateCities(event) {
      console.log(this.$refs.input);
      // `this` inside methods point to the Vue instance
      // `event` is the native DOM event
      event.preventDefault();
      this.openBox = true;
      this.restOfCities = [
        { name: 'Montreal', selected: false },
        { name: 'Vancouver', selected: false },
        { name: 'Toronto', selected: false },
        { name: 'Calgary', selected: false },
      ];
      _.remove(this.restOfCities, this.selected);
    },
    setCity(name, event) {
      // `this` inside methods point to the Vue instance
      // `event` is the native DOM event
      event.preventDefault();
      this.selected = name;
      _.remove(this.restOfCities, { name, selected: false });
      this.restOfCities = [];
      this.openBox = false;
    },
    searchSub() {
      console.log(this.dropdownMainSelected);
    },
    setType(type, event) {
      event.preventDefault();
      this.selectedType = type.name;
    },
    validEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    loadSelect(name, index, event) {
      event.preventDefault();
      console.log('loading');
      console.log(name);
      this.setDropdownMainCatIndex({ index });
      this.SetMainCatagory();
      this.ResetFirstOption();
      this.selectedType = name;
    },
    search(event) {
      event.preventDefault();
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 500);
      if (this.mainCatSelected.name === 'Please Select a Category' || this.subCatSelected.name === 'Please Select a Subcatagory') {
        alert('Please Select an option');
      } else {
        this.$router.replace({
          name: 'search',
          params: {
            categoryname: this.mainCatSelected.name, subcatagoryname: this.subCatSelected.name, categoryid: this.dropdownIndex, pagenum: 1,
          },
        });
        this.getTestKitProducts();
      }
    },
    handleBlur() {
      this.restOfCities = this.selected;
    },
  },
  async created() {
    console.log('component mounted');
    await this.getMainOptions();
  },
  async mounted() {
    await this.getLatest();
  },

};
</script>

<style lang="css">
@import '../../public/build/tailwind.css';
</style>
